import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
import { EmailInput } from '../../../components/TextFields';
import ResetPassword from '../resetpassword/Reset';
import { useAlert } from '../../../components/Notification';

import { handleSendOTP } from '../../../stores/services/authApis/index';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [isEmailValid, setisEmailValid] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);
  const showAlert = useAlert();

  const Reset = async () => {
    await handleSendOTP({ userEmail: email })
      .then(() => {
        showAlert('OTP sent', 'success');
        setIsOtpSend(true);
      })
      .catch(() => {
        showAlert('Check your Email', 'warning');
      });
  };

  if (isOtpSend) {
    return <ResetPassword email={email} />;
  }

  return (
    <>
      <div className="form_header">
        <Typography variant="h5" align="center" fontWeight="bold">
          Forgot Password
        </Typography>
      </div>
      <div className="auth_form">
        <div className="auth_formitem">
          <div className="form-input">
            <EmailInput
              value={email}
              handleValid={setisEmailValid}
              onChange={setEmail}
              error={isEmailValid}
            />
          </div>
        </div>
        <Divider component="div" role="presentation" />
        <div className="auth_formitem">
          <button
            className="submit_Button"
            disabled={!isEmailValid}
            color="primary"
            onClick={() => {
              Reset();
            }}
          >
            Reset Your Password
          </button>
          <Typography
            variant="body2"
            align="center"
            className="submit_Button-text"
          >
            Don&apos;t remember you email? <br />
            <RouterLink className="routerLink" to="/forgot-password">
              Contact Support
            </RouterLink>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
